import React, { FC, useRef } from 'react';
import SunEditor from 'suneditor-react';
import './Editor.scss';
import { buttonList, iconSet, setImageOptions } from './config';
import { fileUpload } from 'app/components/helpers';
import { useGenerateContainerSasToken } from 'app/services/article-api';
import SunEditorCore from 'suneditor/src/lib/core';
import { addSasTokenToResponse } from 'app/utils/blobStorageHelpers';
import { Entity, BlobStorageContainer, BlobStorageSubfolder, StringConstants } from 'app/utils/constants';
import { IBlobUploadParams } from 'app/models/common/post';

interface IProps {
    setContent?: (content: string) => void;
    content: string;
    token?: string;
    handleFileUploadProgress?: (loadedBytes: number, totalBytes: number) => void;
}

const Editor: FC<IProps> = (props: IProps) => {
    const { handleFileUploadProgress, setContent, content } = props;
    const { refetch: getToken } = useGenerateContainerSasToken({entity: StringConstants.ARTICLE, containerName: BlobStorageContainer.ARTICLE_FILES});
    const editorInstance = useRef(null);

    const imageUploadHandler = (files: File[], info: object, uploadHandler: Function) => {
        const file = files[0];
        const blobName = StringConstants.NEW_BLOB + new Date().getTime();
        try {
            getToken().then((res) => {
                const blobUploadParams: IBlobUploadParams = {
                    file: file,
                    blobName: blobName,
                    container: BlobStorageContainer.ARTICLE_FILES,
                    subfolder: BlobStorageSubfolder.NONE,
                    token: res.data
                };

                fileUpload(blobUploadParams, handleFileUploadProgress)
                    .then((res) => {
                        const response = {
                            result: [
                                {
                                    url: res._response.request.url.split(/[?#]/)[0],
                                    name: file.name,
                                    size: file.size
                                }
                            ]
                        };

                        addSasTokenToResponse(Entity.ARTICLE, BlobStorageContainer.ARTICLE_FILES, response)
                        .then((res) => {
                            uploadHandler(res);
                        });
                    })
                    .catch((err) => {
                        handleFileUploadProgress(1, 1);
                        return uploadHandler();
                    });
            });
        } catch (err) {
            handleFileUploadProgress(1, 1);
            return uploadHandler();
        }
    };

    const getEditor = (editor: SunEditorCore) => (editorInstance.current = editor);

    return (
        <div>
            <SunEditor
                autoFocus={true}
                setContents={content}
                setOptions={{
                    buttonList: buttonList.responsive,
                    icons: iconSet,
                    mode: 'classic',
                    ...setImageOptions,
                    attributesWhitelist: {
                        all: 'style',
                        input: 'checked',
                        img: 'width|height'
                    }
                }}
                onChange={setContent}
                onImageUploadBefore={imageUploadHandler}
                getSunEditorInstance={getEditor}
            />
        </div>
    );
};

export default Editor;
